/**
 * Read email from persisted session (optimistic restore before React auth state catches up).
 * Avoids calling Whop-gated APIs without ?email= which returns 401 and flashes an error banner.
 */
export function getStoredRiskloUserEmail() {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem('risklo_user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    const e = typeof u?.email === 'string' ? u.email.trim() : '';
    return e || null;
  } catch (_e) {
    return null;
  }
}

export function getRiskloAuthToken() {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem('risklo_auth_token');
}
